import { atom } from 'jotai';

import { getMenuMap } from '@/config';

import { menuAtom } from './common';

interface PayloadParams {
  selectKey: string; // 选中的侧边栏key
  isSubRoute: boolean; // 是否为二级栏，是：true，不是：false(表示在三级栏)
}

export const breadcrumbAtom: any = atom([]);

const getBreadcrumb = (menuList: any, key: any) => {
  const menuItem = menuList.find((item: any) =>
    item.menu_auth.some((auth: any) => auth.submenu_name === key.selectKey)
  );

  if (!menuItem) return [];

  const submenuItem = menuItem.menu_auth.find((auth: any) => auth.submenu_name === key.selectKey);

  if (key.isSubRoute) {
    return [menuItem.menu_i18n, submenuItem.submenu_i18n]; // 二级栏面包屑
  }
  const menuMap = getMenuMap();

  const childItem = menuMap[key.selectKey].children.find((child: any) =>
    window.location.hash.includes(child.submenu_name)
  );

  return [menuItem.menu_i18n, submenuItem.submenu_i18n, childItem?.submenu_i18n]; // 三级栏面包屑
};

export const setBreadcrumbAtom = atom(null, (get, set, payload: PayloadParams) => {
  const menuList = get(menuAtom); // 侧边栏数据

  set(breadcrumbAtom, getBreadcrumb(menuList, payload)); // payload: 入参
});
